/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback, useEffect, useState } from 'react';
import Avatar from 'react-avatar';
import { useDispatch } from 'react-redux';
import { openDialog } from '../../../../../../app/dialog/dialog.actions';
import { meetingsSimplePageSelectors } from '../../../../../../app/page/page-storage/meetings-simple/meetings-simple.selectors';
import { meetingSimpleSelectors } from '../../../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { formatDateWithoutOrdinals } from '../../../../../../utils/date.utils';
import { useSelect, useSelectWithParams } from '../../../../../../utils/selector.utils';
import { Tooltip } from '../../../../../common/Tooltip';
import { TaskMenu } from '../TaskMenu';
import { TaskAvatar } from './TaskAvatar';
import { ITaskWidgetParams } from './types';
import { TaskStatusMenu } from '../TaskStatusMenu';

export const TaskWidget: FunctionComponent<ITaskWidgetParams> = ({ task, provided, meetingId }) => {
  const dispatch = useDispatch();

  const openUpdateTask = useCallback(() => {
    if (task) {
      dispatch(
        openDialog('taskFormDialog', {
          task,
          userId: task.userId,
          meetingId,
        }),
      );
    }
  }, [dispatch, task, meetingId]);
  const filteredMeetingIds = useSelect(meetingsSimplePageSelectors.selectFilteredMeetings);
  const [filteredTask, setFilteredTask] = useState(false);
  useEffect(() => {
    if (task) {
      setFilteredTask(task.meetingIds.every((id) => filteredMeetingIds.includes(id)));
    }
  }, [filteredMeetingIds, task]);
  const meetings = useSelectWithParams(meetingSimpleSelectors.selectResourcesById, task ? task.meetingIds : []);
  const isHomePage = window.location.href.endsWith('/home') ? true : false;

  return task ? (
    <a
      draggable={false}
      id={task.id}
      className="card todo-card panel"
      data-id="111"
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      ref={provided.innerRef}
      style={filteredTask === true ? { display: 'none' } : {}}
    >
      <div className="card-header">
        <TaskStatusMenu task={task} />
        <TaskMenu task={task} />
      </div>

      <div className="card-body" onClick={openUpdateTask}>
        <div className="card-desc">{task.title}</div>
      </div>

      <div className="card-footer" style={{ justifyContent: 'space-between' }}>
        <div className="flex" style={{ alignItems: 'center' }}>
          <TaskAvatar
            meetingIds={task.meetingIds}
            userIds={[task.userId]}
            taskType={task.type}
            currentMeetingId={meetingId}
          />
          <div className="blueGray f-1" style={{ paddingTop: '10px' }}>
            Due: <span className="card-due">{formatDateWithoutOrdinals(task.dueDate)}</span>
          </div>
        </div>
        {meetings && isHomePage ? (
          <div className="group-stack text-right" style={{ marginTop: '8px' }}>
            {meetings.map((meeting) =>
              meeting && meeting.image?.length > 1 ? (
                <Tooltip content={meeting.title} direction="top" bgColor="#13ac92" textColor="white" key={meeting.id}>
                  <span className="btn-badge white-bg f-1 bold" key={`meetingId-${meeting.id}`}>
                    <img src={meeting.image} alt="" style={{ borderRadius: '50%', height: '30px', width: '30px' }} />
                  </span>
                </Tooltip>
              ) : (
                <div key={meeting && meeting.id} className="menu-img ml-auto">
                  {meeting && (
                    <Avatar
                      title="Review KPIs"
                      name={meeting.title}
                      alt="review KPIs"
                      color={meeting.color}
                      size="25"
                    />
                  )}
                </div>
              ),
            )}
          </div>
        ) : (
          <></>
        )}
      </div>
    </a>
  ) : (
    <></>
  );
};
